import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import SVGImage from '~/components/Image/SVGImage'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { AppLanguage } from '~/types/locale'
import { ButtonPrimary } from '~/components/Buttons'
import { CurriculumVideoProductAPIStat } from '~/redux/apis/user-stats-api'
import useCurriculumVideoCardStats from '~/statistics/hooks/useCurriculumVideoCardStats'

import TimeStat from '../../ProfileCards/TimeStat'
import PieProgress from '../PieProgress'

import ActivitySetsSummary from './ActivitySetsSummary'

export default function Details({ product }: { product: CurriculumVideoProductAPIStat }): React.ReactElement {
  const { t } = useTranslation('statistics')
  const { locale } = useRouter()

  const {
    activitiesSummary: { totalSetsCount, setsCompletedCount },
    totalAnswered,
    videoProgress: { days, hours, minutes },
    video: { totalCount: totalVideoCount, watchedCount: watchedVideoCount },
    videoProgressBarData,
    activitySetsProgress,
    productHref,
  } = useCurriculumVideoCardStats(product)

  const onClickContinueBtn = (): void => {
    statisticsAnalytics.logButtonClick('contiue')
  }

  return (
    <div>
      <div className="flex space-x-4 my-4 pt-2">
        <ActivitySetsSummary
          setsCompletedCount={setsCompletedCount}
          setsProgress={activitySetsProgress}
          totalAnswered={totalAnswered}
          totalSetsCount={totalSetsCount}
        />
        <div className="w-full grow font-semibold rounded overflow-hidden shadow-card space-y-3 py-2">
          <p className="text-center">
            <span className="text-purple">{t('videos')}</span> {watchedVideoCount}/{totalVideoCount}
          </p>
          <PieProgress
            imgAltText={t('alt_texts.video_camera')}
            imgSrcKey="scoreboard/video-white.svg"
            progressBarData={videoProgressBarData}
            totalSlices={totalVideoCount}
          />
          <div className="flex items-center justify-center">
            <SVGImage
              alt={t('alt_texts.clock')}
              className="mr-2"
              height={20}
              srcKey="scoreboard/clock.svg"
              width={20}
            />
            <TimeStat days={days} hours={hours} minutes={minutes} />
          </div>
        </div>
      </div>

      <ButtonPrimary
        className="ml-auto mt-4 px-2"
        href={productHref}
        locale={locale as AppLanguage}
        noPadding
        onClick={onClickContinueBtn}
        size="medium"
      >
        {t('continue')}
      </ButtonPrimary>
    </div>
  )
}
